import { render, staticRenderFns } from "./T1AsideAwards.vue?vue&type=template&id=551c6a74&scoped=true&"
var script = {}
import style0 from "./T1AsideAwards.vue?vue&type=style&index=0&id=551c6a74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551c6a74",
  null
  
)

export default component.exports